import { defineMessages } from 'react-intl';

import { CountryCode } from '@/shared/models/country-code';

import { ISupplementaryDocsGroup } from './types';

const CLEAN_RECORD_DOC_TYPES = {
  certificate: 'clean_record',
  signature: 'clean_record_signature',
} as const;

const messages = defineMessages({
  certificateWrongFormat: {
    defaultMessage: 'Wrong file format. Please upload a PDF file.',
    id: 'clean_record_wrong_format',
    description: 'Criminal record certificate: error for a certificate file that is not PDF',
  },
  wrongFormat: {
    defaultMessage: 'Wrong file format. Please upload a .sig file.',
    id: 'clean_record_signature_wrong_format',
    description: 'Criminal record certificate: error for a signature file that is not .sig',
  },
});

// the certificate is checked on Gosuslugi, which needs the original PDF; the .sig is the
// detached signature Gosuslugi issues with it, shown right under the certificate and
// required with it
const CLEAN_RECORD_GROUP: ISupplementaryDocsGroup = {
  countries: [CountryCode.Russia],
  fileFormat: {
    extensions: ['.pdf'],
    wrongFormatError: messages.certificateWrongFormat,
  },
  questions: [
    {
      docType: CLEAN_RECORD_DOC_TYPES.signature,
      silentReview: true,
      required: true,
      fileFormat: {
        extensions: ['.sig'],
        wrongFormatError: messages.wrongFormat,
      },
    },
  ],
};

export { CLEAN_RECORD_GROUP, CLEAN_RECORD_DOC_TYPES };
